<script>
import { mapState } from 'vuex'
import PointList from '@components/point-list'
import PointDetail from '@components/point-detail'

export default {
  metaInfo: {
    title: 'Point',
    meta: [{ name: 'description', content: 'Point' }],
  },

  components: { PointList, PointDetail },

  data() {
    return {
      item: {},
      currentView: 'PointList',
    }
  },

  computed: {
    ...mapState('app', ['currentProperty']),
    currentProps() {
      const props = { propertyId: this.currentProperty.id }

      if (this.currentView === 'PointDetail') {
        props.item = this.item
      }

      return props
    },
  },

  methods: {
    onEvent(data) {
      this.currentView = data.currentView
      this.item = data.item ? data.item : {}
    },
  },
}
</script>

<template>
  <component :is="currentView" v-bind="currentProps" @event="onEvent" />
</template>
